/**
 * Get the main domain and top level domain labels
 * @example getMainAndToplevelDomain('www.mijn.test.zorgenzekerheid.nl');
 * // returns 'zorgenzekerheid.nl'
 * @param hostname - hostname property from window.location
 */
export default (hostname) => {
    if (hostname === 'localhost')
        return hostname;
    const segments = hostname.split('.');
    const [mainDomain, topLevelDomain] = segments.splice(-2);
    return `${mainDomain}.${topLevelDomain}`;
};
